import { EntitySearchResult } from 'components'
// import { RootStore } from 'mobx-stores'
import { EntitySearchBase } from 'mobx-stores/utils'
import { StoreDTO } from 'models'

export class StoreSearchStore extends EntitySearchBase<StoreDTO> {
  private rootStore: any

  constructor (rootStore: any) {
    super()
    this.rootStore = rootStore
  }

  public onComponentMount = (): void => {
    this.setArguments({
      loadEntities: this.rootStore.storesMainStore.loadStores,
      onEntityActionButtonClick: this.rootStore.userProfilePageStore
        .onAssignStoreClick,
      searchedPropertySelector: store => store.name,
      entityActionButtonLabel: 'Assign'
    })
  }

  public get entitiesList (): StoreDTO[] {
    return this.rootStore.storesMainStore.storesList
  }

  public get searchResultsToDisplay (): EntitySearchResult[] {
    return this.searchResultsFiltered(
      this.rootStore.userProfilePageStore.assignedStores
    )
  }
}
